import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const Graduated: FC<Props> = (props) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="Graduated icon">
      {/* <title>Graduated icon</title> */}
      <path
        d="M8.41725 10.9058L3.28565 8.39769C2.18811 7.86129 2.18811 6.29743 3.28492 5.76106L8.1867 3.36528C8.8296 3.05076 9.58125 3.05076 10.2241 3.36528L15.1317 5.76325C16.2292 6.29962 16.2292 7.86422 15.1317 8.40054L10.2263 10.7978C9.58125 11.1131 8.82742 11.1131 8.18227 10.7978L5.06625 9.27482"
        stroke={props.fill || "currentColor" || "black"}
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9623 7.07275L15.9375 11.1331"
        stroke={props.fill || "currentColor" || "black"}
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.06689 9.27588V13.0042C5.06689 13.6464 5.44783 14.2375 6.04111 14.4827C8.12235 15.3416 10.1949 15.3525 12.2594 14.4878C12.8483 14.2411 13.2255 13.6515 13.2255 13.013V9.34375"
        stroke={props.fill || "currentColor" || "black"}
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Graduated;
